import useRequest from '@space-shell/common/hooks/useRequest'
import { ProductEndpoints, ProductService } from '@space-shell/common/services/product'
import { useMembershipStore, useViewAsStore } from '@space-shell/core/store'

export type PurchasesParams = {
  params?: {
    pageSize?: number
    currentPage?: number
  }
  options?: {
    enabled?: boolean
  }
}

const usePurchases = ({
  params: { pageSize, currentPage } = {},
  options: { enabled = true } = {}
}: PurchasesParams) => {
  const { role: viewAsRole, isEnabled: isViewAsEnabled } = useViewAsStore()
  const { membershipSlug } = useMembershipStore()

  const queryKeys = [pageSize, currentPage, viewAsRole, isViewAsEnabled].map((value) =>
    (value || '').toString()
  )

  return useRequest(
    [ProductEndpoints.purchased(membershipSlug), ...queryKeys],
    () =>
      ProductService.getPurchasedProducts(membershipSlug, {
        size: pageSize,
        page: currentPage
      }),
    { enabled }
  )
}

export default usePurchases
